import React, { useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0e1a] flex items-center justify-center text-cyan-400">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }
  if (!user) {
    const state = { from: location.pathname };
    return <Navigate to="/admin/login" state={state} replace />;
  }
  return children;
};

export default ProtectedRoute;
